import { createNamedStyles, IStyles } from "../../shared/CreateNamedStyles";

export const StyledModalStyles = createNamedStyles({
  dialogContainer: {
    borderRadius: "8px",
    zIndex: "9999 !important",
    "& .MuiDialog-paper": {
      maxWidth: "900px",
      width: "90%",
    },
  },
  dialogContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 0,
  },
  dialogActions: {
    padding: 0,
    backgroundColor: "rgba(128, 128, 128, 0.1) !important",
    justifyContent: "center",
  },
  boxContainer: {
    display: "flex",
    marginLeft: "auto",
    margin: "0 56px 0 56px",
    paddingTop: "24px",
    paddingBottom: "24px",
  },
});

export const StyledDialogContainer = (isDialogPolicy: boolean) => {
  const containerStyles: IStyles = {
    dialogContainer: {
      borderRadius: "8px",
      zIndex: 9999,
      "& .MuiDialog-paper": {
        maxWidth: isDialogPolicy ? "800px" : "600px",
        height: isDialogPolicy ? "75%" : "auto",
      },
      margin: "auto",
    },
  };
  return containerStyles.dialogContainer;
};

export const StyledTitle = (isDialogPolicy: boolean) => {
  const containerStyles: IStyles = {
    title: {
      marginTop: isDialogPolicy ? "10px" : "24px",
    },
  };
  return containerStyles.title;
};

export const StyledDialogContent = (isDialogPolicy: boolean) => {
  const containerStyles: IStyles = {
    dialogContent: {
      display: "flex",
      justifyContent: isDialogPolicy ? "left" : "center",
      paddingBottom: 0,
    },
  };
  return containerStyles.dialogContent;
};
